import { render, staticRenderFns } from "./AssetTrayModal.vue?vue&type=template&id=680be056&"
import script from "./AssetTrayModal.vue?vue&type=script&lang=js&"
export * from "./AssetTrayModal.vue?vue&type=script&lang=js&"
import style0 from "./AssetTrayModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports